const packageName = 'assets'

export const GET_ASSETS = `${packageName}/GET_ASSETS`
export const GET_ASSETS_SUCCESS = `${packageName}/GET_ASSETS_SUCCESS`
export const GET_ASSETS_FAIL = `${packageName}/GET_ASSETS_FAIL`

export const POST_ASSET = `${packageName}/POST_ASSET`
export const POST_ASSET_SUCCESS = `${packageName}/POST_ASSET_SUCCESS`
export const POST_ASSET_FAIL = `${packageName}/POST_ASSET_FAIL`
